import { ApplicationConfig, APP_INITIALIZER } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { provideHttpClient } from '@angular/common/http';
import { PublicClientApplication } from '@azure/msal-browser';
import { environment } from '../environments/environment';

export const msalInstance = new PublicClientApplication({
  auth: {
    clientId: environment.msal.auth.clientId,
    authority: environment.msal.auth.authority,
    knownAuthorities: environment.msal.auth.knownAuthorities,
    redirectUri: environment.msal.auth.redirectUri
  },
  cache: {
    cacheLocation: environment.msal.cache.cacheLocation
  }
});

function initializeMsal() {
  return async () => {
    await msalInstance.initialize();
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideHttpClient(),
    {
      provide: APP_INITIALIZER,
      useFactory: initializeMsal,
      multi: true
    }
  ]
};